/**
 * Detects a failed lazy-chunk load (webpack `ChunkLoadError`).
 *
 * Used by the app-level and section-level error boundaries to distinguish a
 * transient chunk-load failure (worth a cache-busting `?retry=N` reload) from a
 * genuine render error (which a reload won't fix). Matches either the canonical
 * `ChunkLoadError` name or the "Loading chunk … failed" message text, since the
 * name is occasionally lost when the error is re-thrown across async boundaries.
 *
 * @param error The caught error (nullable — boundaries hold `Error | null` state).
 * @returns `true` if the error looks like a chunk-load failure.
 */
export const isChunkLoadError = (error: Error | null): boolean => {
  if (!error) return false;
  return error.name === 'ChunkLoadError' || /loading chunk/i.test(error.message ?? '');
};
